import {findIdForKey} from "./helpers";
import * as Constants from "../constants/Constants";

// Destructuring the Open Api JSON paths object
export const convertJSONintoPreferredFormat = (path, method, schemas) => {
  const methodType = method.type;
  const headers = method.headers.map((item) => {
    const {name, in: In, required, schema: {type} = {}} = item;
    return {
      name,
      in: In,
      type,
      required: required?.toString(),
    };
  });
  const parameters = method.parameters.map((item) => {
    const {name, in: In, required, schema: {type} = {}} = item;
    return {
      name,
      in: In,
      type,
      required: required?.toString(),
    };
  });
  const responsesTable = method.responses.map((item) => {
    const {status, response} = item;
    const {
      description = "",
      content: {
        ["application/json"]: {schema: {$ref: refvalue, value} = {}} = {},
      } = {},
    } = response || {};
    const schemaId = findIdForKey(schemas, refvalue);
    return {
      status,
      description,
      schema: schemaId!== null ? refvalue+"/"+schemaId : refvalue,
    };
  });

  const requestResponse = method.responses.map((item) => {
    const {status, response} = item;
    const Description = response?.description;
    const Schema =
      response?.content &&
      Object.entries(response?.content).map((item) => {
        const {schema: {value = {}} = {}} = item[1];
        return value;
      });
    return {
      Description,
      Schema,
    };
  });

  const requestBodyParams = method?.requestBody;
  const content = requestBodyParams?.content;
  const requestParameters =
    content &&
    Object.entries(content).map((item) => {
      let refAddress;
      if (item[1]?.schema?.type=== Constants.Values.TYPE_ARRAY) {
        const {$ref: refvalue={}} = item[1].schema.items;
        refAddress= refvalue.replace("#/components/schemas/", "");
      } else {
        const {schema: {$ref: refvalue} = {}} = item[1];
        refAddress = refvalue;
      }
      const schemaId = findIdForKey(schemas, refAddress);
      return {
        Type: item[0],
        Name: refAddress+"/"+schemaId,
      };
    });
  const requestBody =
    content &&
    Object.entries(content).map((item) => {
      const {schema: {value = {}} = {}} = item[1];
      return value;
    });
  const methodPath = `${methodType.toUpperCase()}  ${path}`;
  const methodSummary = method.name;
  const operationSummary = method.operationSummary;
  return {
    headers,
    parameters,
    responsesTable,
    methodType,
    requestResponse,
    methodPath,
    requestBody,
    methodSummary,
    operationSummary,
    path,
    requestParameters,
  };
};

